import * as React from 'react'
import Button from '@mui/material/Button'
import TheatersIcon from '@mui/icons-material/Theaters'

interface IProps {
  href: string
}

const VideoButton: React.FC<IProps> = ({
  href,
}) => {
  return (
    <Button
      variant='contained'
      sx={{
        color: '#FFFFFF',
        backgroundColor: '#9E5D12',
        borderRadius: '20px'
      }}
      target='_blank'
      rel='noopener noreferrer'
      href={href}
    >
      <TheatersIcon/>Se föreställningen här
    </Button>
  )
}

export default VideoButton